<template>
  <v-layout>
    <v-flex class="xs10 offset-xs1">
      <vue-headful :title="pageTitle"/>
      <h2 class="text-xs-center">Инструкция</h2>
      <v-card>
        <v-card-text>
          <h4 class="text-xs-center">ПРЕДУВЕДОМЛЕНИЕ № 1</h4>
          <p>Аттестуемое лицо предупреждено о том, что в соответствии с пунктом 22 Постановления
            правительства РФ от 26.02.2015 года №172 «О порядке аттестации сил обеспечения
            транспортной безопасности», а так же в соответствии с Приказом Федерального агентства
            атомобильного транспорта (Росавтодор) от 04.04.2016 № 518 «Об утверждении требований к
            средствам аудио- и видеофиксации и порядка их использования при проведении проверок в
            ходе аттестации сил обеспечения транспортной безопасности в сфере дорожного хозяйства,
            автомобильного транспорта и городского наземного электрического транспорта», в ходе
            проведения данной проверки используются технические средства аудио- и видеофиксации.
            Процесс тестирования осуществляется на условиях непрерывности, недопустимости
            использования методической помощи, литературы, сторонних лиц, а также технических
            средств связи. Перед началом проведения тестирования личность аттестуемого лица
            удостоверена посредством сверки документов, удостоверяющих личность, с протоколом о
            присвоении индивидуального идентификационного номера. В соответствии с Приказом
            Минтранса России от 21.08.2014 года №231 «Об утверждении требований к знаниям,
            умениям, навыкам сил обеспечения транспортной безопасности, личностным
            (психофизиологическим) качествам, уровню физической подготовки отдельных категорий сил
            обеспечения транспортной безопасности, включая особенности проверки соответствия
            знаний, умений, навыков сил обеспечения транспортной безопасности, личностных
            (психофизиологических) качеств, уровня физической подготовки отдельных категорий сил
            обеспечения транспортной безопасности применительно к отдельным видам транспорта»
            аттестуемое лицо проходит письменный (компьютерный) тест, содержащий 50 вопросов с
            четырьмя многовариантными ответами. Вопросы для одной категории аттестуемых лиц
            имеют равный уровень сложности. Предлагаемые вопросы в виде тестов имеют один
            однозначно определяемый ответ. Настоящая проверка проводится с использованием
            компьютерного тестирования. За каждый правильный ответ на вопрос в форме теста
            аттестуемое лицо получает 1 балл, за неправильный ответ или отсутствие ответа - 0 баллов.</p>
        </v-card-text>
      </v-card>
      <v-card class="my-4">
        <v-card-text>
          <h4 class="text-xs-center">ПРЕДУВЕДОМЛЕНИЕ № 2</h4>
          <p>
            Данный аппаратно-программный комплекс предназначен для проверки знаний, умений и
            навыков аттестуемых лиц требованиям законодательства Российской Федерации о
            транспортной безопасности в ходе процедуры аттестации сил транспортной безопасности и
            отвечает требованиям:</p>
          <ol>
            <li>Федерального закона Российской Федерации от 09.02.2007 года №16-ФЗ «О транспортной безопасности»</li>
            <li>Федерального закона Российской Федерации от 27.07.2006 года №152-ФЗ «О персональных данных»</li>
            <li>Федерального закона Российской Федерации от 27.07.2007 года №149-ФЗ «Об информации, информационных
              технологиях
              и о защите информации»
            </li>
            <li>Федерального закона Российской Федерации от 29.12.2012 года №273-ФЗ «Об образовании в Российской
              Федерации»
            </li>
            <li>Постановления Правительства Российской Федерации от 26.02.2015 года №172 «О прядке аттестации сил
              обеспечения
              транспортной безопасности»
            </li>
            <li>Постановления Правительства Российской Федерации от 23 июля 2004 г. №374 «Об утверждении положения о
              Федеральном дорожном агентстве»
            </li>
            <li>Приказа Министерства транспорта Российской Федерации от 21.08.2014 г. №231 «Об утверждении требований к
              знаниям, умениям, навыкам сил обеспечения транспортной безопасности, личностным (психофизиологическим)
              качествам, уровню физической подготовки отдельных категорий сил обеспечения транспортной безопасности,
              включая
              особенности проверки соответствия знаний, умений, навыков сил обеспечения транспортной безопасности,
              личностных
              (психофизиологических) качеств, уровня физической подготовки отдельных категорий сил обеспечения
              транспортной
              безопасности применительно к отдельным видам транспорта»
            </li>
            <li>Приказа Министерства транспорта Российской Федерации от 18.12.2014 № 346
              «Об утверждении структур номеров и форм реестров органов аттестации,
              аттестующих организаций, аккредитованных подразделений транспортной
              безопасности, выданных свидетельств об аттестации сил обеспечения
              транспортной безопасности»
            </li>
            <li>Приказа Росавтодора от 09.06.2016 № 890 «Об утверждении порядка сбора,
              накопления и хранения органами аттестации и/или аттестующими
              организациями в сфере дорожного хозяйства, автомобильного транспорта и
              городского наземного электрического транспорта данных аттестации и
              сведений, связанных с обработкой персональных данных аттестуемых лиц»
            </li>
            <li>Приказа Росавтодора от 04.04.2016 № 518«Об утверждении требований к
              средствам аудио- и видеофиксации и порядка их использования при
              проведении проверок в ходе аттестации сил обеспечения транспортной
              безопасности в сфере дорожного хозяйства, автомобильного транспорта и
              городского наземного электрического транспорта»
            </li>
            <li>Приказа Росавтодора от 07.06.2016 № 861 «Об утверждении перечней
              вопросов, подлежащих применению органами аттестации (аттестующими
              организациями) для проверки соответствия знаний, умений и навыков
              аттестуемых лиц требованиям законодательства российской федерации о
              транспортной безопасности в сфере дорожного хозяйства, автомобильного
              транспорта и городского наземного электрического транспорта»
            </li>
            <li>Приказа Росавтодора от 04.04.2016 №520 «Об утверждении порядка
              присвоения уникального идентификационного номера аттестуемым лицам при
              проведении аттестации сил обеспечения транспортной безопасности в
              установленной сфере деятельности»
            </li>
          </ol>
        </v-card-text>
      </v-card>
      <v-btn class="mx-auto d-block" color="primary" @click="start">{{ startBtnText }}</v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import AttestationService from '@/services/AttestationService'
import SettingsService from '@/services/SettingsService'

export default {
  data: () => ({
    pageTitle: SettingsService.pageTitle('Инструкция'),
    hrefTo: '',
    isStarted: false,
    attestationService: undefined
  }),
  computed: {
    isTraining () {
      let isTraining = sessionStorage.getItem('isTraining')
      return isTraining.toLowerCase() === 'true' || false
    },
    startBtnText () {
      return (this.isStarted ? 'Продолжить' : 'Начать').concat(this.isTraining ? ' тренировку' : ' аттестацию')
    }
  },
  methods: {
    start () {
      this.attestationService.startStudentAttestation((data) => {
        let info = data.info
        if (info) {
          this.attestationService.setTime(info.testTimeLeft)
          switch (false) {
            case info.testStageEnded:
              this.hrefTo = '/attestation/test'
              break
            case info.thematicStageEnded:
              this.hrefTo = '/attestation/thematic'
              break
            case info.practiceStageEnded:
              this.hrefTo = '/attestation/practice'
              break
            default:
              this.hrefTo = '/attestation/result/' + info.id
              break
          }
        }
        this.$router.push(this.hrefTo)
      })
    }
  },
  created () {
    this.attestationService = new AttestationService(this.$store)
    this.attestationService.startStudentAttestation((data) => {
      let info = data.info
      if (info && info.practiceStageEnded && info.thematicStageEnded && info.testStageEnded) {
        this.$router.push('/attestation/result/' + info.id)
        return
      }
      if (info && info.status === 'IN_PROCESS') {
        this.isStarted = true
      }
    })
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/student/attestation/Intro.vue